import * as HttpService from "../../../../service/HttpService"

/** 系统管理  -> 用户管理服务 **/

/**
 * 查询用户列表
 * @param searchParams 查询参数
 */
export const getUserList = (searchParams) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/usermgmt/dataList", searchParams);
}

/**
 *  新增用户
 * @param userInfo 用户信息
 */
export const addUser = (userInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/usermgmt/addUserDo", userInfo);
}

/**
 * 删除用户
 * @param userNo 用户编号
 */
export const deleteUser = (userNo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/usermgmt/deleteUser/" + userNo);
}

/**
 * 编辑用户
 * @param userInfo 用户信息
 */
export const editUser = (userInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/usermgmt/editUserDo", userInfo);
}

/**
 * 重置密码
 * @param userNo 用户账号
 * @param password 新密码
 */
export const resetPassword = (userNo, password) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/usermgmt/modifyUserPasswordDo", {userNo, newUserPasswd: password})
}


/**
 * 通过用户编号加载用户信息
 * @param userNo 用户编号
 */
export const loadUserByNo = (userNo) => {
    return HttpService.get(HttpService.DOMAIN + "/sysmgmt/usermgmt/loadUser/" + userNo);
}
